export const GET_EMAIL_TEMPLATE_REQUEST = "GET_EMAIL_TEMPLATE_REQUEST"
export const GET_EMAIL_TEMPLATE_SUCCESS = "GET_EMAIL_TEMPLATE_SUCCESS"
export const GET_EMAIL_TEMPLATE_FAILURE = "GET_EMAIL_TEMPLATE_FAILURE"

export const POST_EMAIL_TEMPLATE_REQUEST = "POST_EMAIL_TEMPLATE_REQUEST"
export const POST_EMAIL_TEMPLATE_SUCCESS = "POST_EMAIL_TEMPLATE_SUCCESS"
export const POST_EMAIL_TEMPLATE_FAILURE = "POST_EMAIL_TEMPLATE_FAILURE"